import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from '../App';
import WorkflowListPage from '../pages/workflow/WorkflowListPage';
import WorkflowEditorPage from '../pages/workflow/WorkflowEditorPage';

// Create React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
    },
  },
});

// 主布局组件 - 包含 QueryClientProvider
function RootLayout() {
  return (
    <QueryClientProvider client={queryClient}>
      <Outlet />
    </QueryClientProvider>
  );
}

export function Router() {
  return (
    <BrowserRouter basename="/product-team-v3">
      <Routes>
        <Route element={<RootLayout />}>
          {/* 主应用 - 设计器 */}
          <Route path="/" element={<App />} />
          
          {/* 工作流管理路由 */}
          <Route path="/workflow" element={<WorkflowListPage />} />
          <Route path="/workflow/:id" element={<WorkflowEditorPage />} />
          
          {/* 404 重定向到首页 */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default Router;
